export default {
      id: "twitter-icon-usage",
      viewBox: "0 0 19 17",
      url: "/" + "sprite.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }